/**
 * Checks whether or not an element is a Number that larger than 0 and smaller than Infinity
 *
 * @param e element
 * @returns {boolean}
 */
export const validNumber = (e: number) =>
    !isNaN(e) && 0 < e && Number.POSITIVE_INFINITY > e;

/**
 * Sets the state asynchronously by resolving it through a promise
 *
 * @param self
 * @param state
 * @returns {Promise<unknown>}
 */
export const asyncState = (self: any, state: any) =>
    new Promise(resolve => self.setState(state, resolve));
